<template>
    <div class="UtilitiesTab">
      <div class="container-fluid">
          <div class="row margin-Top-2Perc margin-bottom-2Perc margin-left-0point3Perc grey-border">
              <div class="col-md-6 col-lg-6 font-size-18px padding-top-bottom-point-7Perc cursor-pointer padding-Left-0px padding-right-0px" v-bind:class="{'background-gray': currentSelectedTab === 1 }" v-on:click="updateSelectedOption($event, 1)">
                Complete User Course
              </div>
              <div class="col-md-6 col-lg-6 font-size-18px padding-top-bottom-point-7Perc cursor-pointer padding-Left-0px padding-right-0px" v-bind:class="{'background-gray': currentSelectedTab === 2 }" v-on:click="updateSelectedOption($event, 2)">
                Challenge Allocation
              </div>
          </div>      
      </div>
    </div>    
</template>

<script>
export default {
  data: function () {
    return {
      currentSelectedTab: 1
    }
  },
  components: {},
  methods: {
    updateSelectedOption: function (event, flagToUpdate) {
      if (this.currentSelectedTab !== flagToUpdate) {
        this.currentSelectedTab = flagToUpdate
        var objToPost = {
          selectedTabNumber: flagToUpdate
        }
        this.$emit('updateTabDetails', objToPost)
      }
    }
  },
  name: 'UtilitiesTab'
}
</script>

<style scoped>
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.padding-right-0px {
  padding-right: 0px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.text-align-center {
  text-align: center;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.background-color-red {
  background-color: red;
}
.border-black {
  border: 1px solid black;
}
.text-align-left {
  text-align: left;
}

.font-size-18px {
  font-size: 17px;
}
.background-gray {
  background-color: #ddd;
}
.padding-top-bottom-point-7Perc {
  padding-top: 0.7% !important;
  padding-bottom: 0.7% !important;
}
.margin-left-1Perc
{
  margin-left:1%;
}
.margin-left-0point3Perc
{
  margin-left:0.3%;
}
</style>





// WEBPACK FOOTER //
// src/components/users/UtilitiesTab.vue